import { ApolloClient, createHttpLink, gql, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getUserEmail } from '../@crema/utility/AppHooks';


const getClient = async () => {

  const fetchDataApi = (email: string, refreshToken: String) => {
    // console.log("in auth in fetchDataApi;")
    const apolloHttpLink1 = createHttpLink({
      uri: process.env.REACT_APP_API_URL,
    });
    const client1 = new ApolloClient({
      link: apolloHttpLink1.concat(apolloHttpLink1),
      cache: new InMemoryCache({
        addTypename: false,
      }),
    });


    return new Promise((resolve, reject) => {
      // console.log("in auth before Promise;");
      client1
        .mutate({
          mutation: gql`
      mutation{
        refreshToken(
      resource:{
        resourceType:User,
        email:"${email}"
          refreshToken:"${refreshToken}"
      
      }){
        status
        message
        tokenresult
      }
      }
      
      
      `,
        })
        .then((result) => {
          // console.log("in auth before Promise;");
          if (result != null && result.data != null && result.data.refreshToken != null && result.data.refreshToken.status == 1) {
            let tokenData = JSON.parse(result.data.refreshToken.tokenresult);
            let refreshToken = tokenData['refreshToken']['token'];
            let accesToken = tokenData['accessToken']['jwtToken'];

            let tokenExpiryDate = tokenData['accessToken']['payload']['exp'];
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("accesToken", accesToken);
            localStorage.setItem("tokenExpiryDate", tokenExpiryDate);
            // console.log("refershtoken::", refreshToken)
            resolve(1);

          } else {
            resolve(0);
            //logout user
          }
          //logout API goes Here
        }).catch(e => {
          let errorObj = JSON.stringify(e);
          if (errorObj) {
            let reqErrObj = JSON.parse(errorObj)
            if (reqErrObj) {
              console.log("abcd", reqErrObj['message']);
              if (reqErrObj['message'] == "Your are not Authorized") {
              }
            }

          }
          // console.log("in patient privacy::", errorObj);
        });

      //add here

    });
  };

  const apolloAuthLink = setContext(async (request, { headers }) => {

    var now = new Date;
    var utc_timestamp = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(),
      now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    let currentTime = Math.floor(utc_timestamp / 1000)


    // get the authentication token from local storage if it exists
    let refreshToken = '';
    let refreshTokenL = localStorage.getItem("refreshToken");
    if (refreshTokenL) {
      refreshToken = refreshTokenL;
    }
    let accesToken = localStorage.getItem("accesToken");
    let tokenExpiryDate = localStorage.getItem("tokenExpiryDate");
    if (tokenExpiryDate != null && accesToken != null) {
      let tokenExpiryDate1 = parseInt(tokenExpiryDate);


      if (tokenExpiryDate1 > currentTime) {
        // console.log("in auth not expired");
        // token not expird
      } else {

        // console.log("in auth before await change;")
        const loggedInEmail = getUserEmail();

        let getdata = await fetchDataApi(loggedInEmail, refreshToken);
        accesToken = localStorage.getItem("accesToken");
        // console.log("in auth after wawait;")
        //call refershToken
      }
    }


    return {
      headers: {
        ...headers,
        authorization: accesToken,
      },
    };
  });
  const apolloHttpLink = createHttpLink({
    uri: process.env.REACT_APP_API_URL,
  });

  const client = new ApolloClient({
    link: apolloAuthLink.concat(apolloHttpLink),
    cache: new InMemoryCache({
      addTypename: false,
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "network-only",
      },
    },
  });

  return client

}

export default getClient; 
